import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-meddata-examples',
  templateUrl: './examples.component.html',
  styleUrls: ['./examples.component.scss'],
})
export class ExamplesComponent implements OnInit, OnDestroy {
  form: FormGroup;
  destroy$ = new Subject();

  data: any = [
    { id: 1, name: 'Abraham 1', value: 1234 },
    { id: 2, name: 'Abraham 2', value: 1234 },
    { id: 3, name: 'Abraham 3', value: 1234 },
    { id: 4, name: 'Abraham 4', value: 1234 },
    { id: 5, name: 'Abraham 5', value: 1234 },
    { id: 6, name: 'Abraham 6', value: 1234 },
    { id: 7, name: 'Abraham 7', value: 1234 },
    { id: 8, name: 'Abraham 8', value: 1234 },
    { id: 9, name: 'Abraham 9', value: 1234 },
  ];

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      primary: [{ value: false, disabled: true }],
      accent: [{ value: true, disabled: true }],
      warn: [{ value: true, disabled: false }],
      selectSearch: ['tae'],
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  async search(e: any) {
    let term = e;
    if (term) {
      console.log(term)
    }
  }

}
